import moment from "moment-jalaali"

moment.loadPersian()

export default () => {
	const app = useNuxtApp()

	moment.locale(app.$i18n.locale.value)

	watch(
		() => [app.$i18n.locale.value],
		() => {
			moment.locale(app.$i18n.locale.value)
		},
		{
			immediate: true
		}
	)

	return moment
}
